/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Metrics_Wpm_Aria_LabelInputs */

const en_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Words Per Minute ${i?.wpm}`)
};

const fr_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mots par minute ${i?.wpm}`)
};

const de_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wörter pro Minute ${i?.wpm}`)
};

const it_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parole al minuto ${i?.wpm}`)
};

const ru_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Слов в минуту ${i?.wpm}`)
};

const es_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palabras por minuto ${i?.wpm}`)
};

const zh_cn2_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每分钟字数 ${i?.wpm}`)
};

const ja_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1分あたりの単語数 ${i?.wpm}`)
};

const hi_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शब्द प्रति मिनट ${i?.wpm}`)
};

const pt_pt2_event_metrics_wpm_aria_label = /** @type {(inputs: Event_Metrics_Wpm_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palavras por minuto ${i?.wpm}`)
};

/**
* | output |
* | --- |
* | "Words Per Minute {wpm}" |
*
* @param {Event_Metrics_Wpm_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_wpm_aria_label = /** @type {((inputs: Event_Metrics_Wpm_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Wpm_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_wpm_aria_label(inputs)
	if (locale === "de") return de_event_metrics_wpm_aria_label(inputs)
	if (locale === "it") return it_event_metrics_wpm_aria_label(inputs)
	if (locale === "ru") return ru_event_metrics_wpm_aria_label(inputs)
	if (locale === "es") return es_event_metrics_wpm_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_wpm_aria_label(inputs)
	if (locale === "ja") return ja_event_metrics_wpm_aria_label(inputs)
	if (locale === "hi") return hi_event_metrics_wpm_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_wpm_aria_label(inputs)
	return en_event_metrics_wpm_aria_label(inputs)
});